export default __webpack_public_path__ + "static/newBgMb-f340f3f42b195455b071ede7767a243b.png";